import TheraLoader from 'components/generic-components/TheraLoader';
import LoadingSpinner from 'icons/LoadingSpinner';

export default function LoadingScreen({ className }: { className?: string }) {
  return (
    <div className={`fixed inset-0 z-[49] h-screen w-full bg-white ${className}`}>
      <div className="flex h-screen items-center justify-center">
        <TheraLoader />
      </div>
    </div>
  );
}

export const Loader = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <LoadingSpinner />
    </div>
  );
};
